<script>
  import { fly } from "svelte/transition";
  import Arrow from "./Arrow.svelte";
  import Button from "./Button.svelte";
  import { options } from "./constants";

  export let directionForward = true;
  export let next;
  export let distanceOptionIdx = 0;

  const maxRange = options.length - 1;

  let selectedIx = distanceOptionIdx;

  const handlePrevious = () => {
    selectedIx = selectedIx - 1 >= 0 ? selectedIx - 1 : maxRange;
  };

  const handleNext = () => {
    selectedIx = selectedIx + 1 <= maxRange ? selectedIx + 1 : 0;
  };

  const submit = () => {
    next(selectedIx);
  };
</script>

<style>
  .wrapper {
    width: 100%;
    padding: 2rem 0;
    overflow: hidden;
  }
  .slider {
    height: 100px;
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: 1fr 4fr 1fr;
  }

  .arrow {
    cursor: pointer;
    width: 2.5rem;
  }

  p {
    margin: 0.25rem;
  }

  .label {
    font-weight: bold;
    font-size: 1.75rem;
  }

  .description {
    font-weight: bold;
    font-size: 1rem;
  }

  @media screen and (min-width: 640px) {
    .label {
      font-size: 2.25rem;
    }

    .description {
      font-size: 1.5rem;
    }

    .arrow {
      width: 2.8rem;
    }

    .slider {
      height: 160px;
    }
  }
</style>

<div
  class="wrapper"
  in:fly={{ x: directionForward ? 200 : -200, duration: 200 }}>
  <div class="slider">
    <div
      class="arrow"
      on:click={handlePrevious}
      style="transform: rotate(180deg)">
      <Arrow />
    </div>

    <div>
      <p class="label">{options[selectedIx].label}</p>
      <p class="description">{options[selectedIx].description}</p>
    </div>
    <div class="arrow" on:click={handleNext}>
      <Arrow />
    </div>
  </div>

  <Button on:click={submit}>GÅ MED I PARADEN!</Button>
</div>
